import { useEffect, useState } from 'react';

export default function useStateWithSessionStorage<T>(
  key: string,
  initialValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const item = sessionStorage.getItem(key);
  if (item) {
    initialValue = JSON.parse(item) as T;
  }
  const [value, setValue] = useState<T>(initialValue);

  useEffect(() => {
    try {
      const item = sessionStorage.getItem(key);
      if (item) setValue(JSON.parse(item) as T);
    } catch (error) {
      console.warn(`Error reading sessionStorage key “${key}”:`, error);
    }
  }, [setValue, key]);

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue];
}
